import { render } from "./PitchList.vue?vue&type=template&id=e3c39050"
import script from "./PitchList.vue?vue&type=script&lang=js"
export * from "./PitchList.vue?vue&type=script&lang=js"

import "./PitchList.vue?vue&type=style&index=0&id=e3c39050&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__